import { Form } from 'antd';
import { RevxInputNumber } from 'components/RevxInputNumber';
import { UOMCoefficientEnum } from 'domains/svcDomain';
import { FieldError } from 'rc-field-form/lib/interface';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigSvcProps } from '..';
import { useSvcDisabled } from '../hook/useSvcDisabled';

interface ICommonQuantityPerBundle extends ConfigSvcProps {
  title?: string;
}

const CommonQuantityPerBundle = (props: ICommonQuantityPerBundle) => {
  const { jobOptionSvc, id, form, formCache, show, title } = props;

  const svcDisabled = useSvcDisabled(props);
  const { t } = useTranslation();

  // const configItem = useAppSelector((state) => state.jobConfig.configItem);
  // const spec = getSelectedSpecItem(configItem).spec;

  const [formErrorTip, setFormErrorTip] = useState<FieldError[]>();

  const checkQuantity = useCallback(
    (_: any, value: number) => {
      if (!value && !svcDisabled) {
        return Promise.reject(t('common.pleaseEnter'));
      }

      if (svcDisabled || value) {
        return Promise.resolve();
      }
      // if (value && spec.quantity / value !== ((spec.quantity / value) | 0)) {
      //   return Promise.reject(
      //     'The number of bundles needs to be divisible by the job quantity'
      //   );
      // } else {
      //   return Promise.resolve();
      // }
    },
    [svcDisabled, t]
  );

  const checkForm = useCallback(async () => {
    try {
      await form?.validateFields();
      setFormErrorTip([]);
    } catch {
      setFormErrorTip(form?.getFieldsError());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form]);

  useEffect(() => {
    if (
      Boolean(
        jobOptionSvc?.uomCoefficient === UOMCoefficientEnum.BUNDLE_COUNT || show
      )
    ) {
      checkForm();
    }
  }, [formCache, checkForm, jobOptionSvc?.uomCoefficient, show]);

  return (
    <>
      {Boolean(
        jobOptionSvc?.uomCoefficient === UOMCoefficientEnum.BUNDLE_COUNT || show
      ) && (
        <div>
          <div
            className="jobconfig-jobOption-content-label"
            style={{ marginBottom: 14 }}
          >
            {title || 'Amount per bundle'}
          </div>
          <Form.Item
            name={[id, 'quantityPerBundle']}
            noStyle
            rules={[
              () => ({
                validator(_, value) {
                  return checkQuantity(_, value);
                },
              }),
            ]}
          >
            <RevxInputNumber
              isInteger
              min={1}
              style={{ marginRight: 10, width: 120, height: 28 }}
              disabled={svcDisabled}
              // autoFocus={!svcDisabled}
            />
          </Form.Item>
          {formErrorTip?.find(
            (item) =>
              item.name.includes('quantityPerBundle') &&
              item.name.includes(id) &&
              item.errors.length
          )?.errors[0] && (
            <div
              className="ant-form-item-explain-error"
              style={{ marginTop: 6 }}
            >
              {
                formErrorTip?.find(
                  (item) =>
                    item.name.includes('quantityPerBundle') &&
                    item.name.includes(id) &&
                    item.errors.length
                )?.errors[0]
              }
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default CommonQuantityPerBundle;
